import axios from "axios";
import { getToken } from './auth';
// import { Message } from 'element-ui';
import * as enums from './enums';
import router from '@/router'
// import Message from '@/components/GlobalMessage.vue';
// let baseUrl = "";
// baseUrl = process.env.VUE_APP_BASE_API;
const service = axios.create({
  baseURL: "serverApi",
  // 超时时间 单位是ms，这里设置了50s的超时时间
  timeout: 50000
});

// 处理请求的参数
let handleData = (config) => {
  /** 处理用户权限 */
  // let params = param2Obj(window.location.href);


  const isToken = (config.headers || {}).isToken === false;
  if (getToken() && !isToken) {
    // console.log('sdkhbsaj');
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  // console.log("config++++++++++++++++",config);
  if (config.method === 'get' && config.data) {
    let url = config.url + '?' + tansParams(config.data);
    url = url.slice(0, -1);
    config.data = {};
    config.url = url;
  }
  // let data = {};
  // config.data = data =
  //   config.method == "get" ? config.data : Object.assign(config.data || {});

  // if (data.formate == "formate") {
  //   /** 将上传的数据转成FormData对象 */
  //   const form = new FormData();
  //   Object.keys(data).forEach(key => {
  //     form.append(key, data[key]);
  //   });
  //   config.data = form;
  // }
    // // 是否需要设置 token
  // const isToken = (config.headers || {}).isToken === false
  // // 是否需要防止数据重复提交
  // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  // if (getToken() && !isToken) {
  //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // console.log("config++++++++++++++++",config);
  // // get请求映射params参数
  // if (config.method === 'get' && config.params) {
  //   let url = config.url + '?' + tansParams(config.params);
  //   url = url.slice(0, -1);
  //   config.params = {};
  //   config.url = url;
  // }
  // if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
  //   const requestObj = {
  //     url: config.url,
  //     data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
  //     time: new Date().getTime()
  //   }
  //   const sessionObj = cache.session.getJSON('sessionObj')
  //   if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
  //     cache.session.setJSON('sessionObj', requestObj)
  //   } else {
  //     const s_url = sessionObj.url;                  // 请求地址
  //     const s_data = sessionObj.data;                // 请求数据
  //     const s_time = sessionObj.time;                // 请求时间
  //     const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
  //     if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
  //       const message = '数据正在处理，请勿重复提交';
  //       console.warn(`[${s_url}]: ` + message)
  //       return Promise.reject(new Error(message))
  //     } else {
  //       cache.session.setJSON('sessionObj', requestObj)
  //     }
  //   }
  // }
  return config;
};
/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

service.interceptors.request.use(
  config => {
    config = handleData(config);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    // console.log("code+++++++++",response);
    switch (response.data.code) {
      case 200:
        return {
          type: enums.resultType.success,
          data: response.data
        };
        break;
      case 401:
        // console.log("message:",Message);
        // Message.info("登录已过期") // info调用
        // this.$refs.message.success(content) // success调用
        // this.$refs.message.error(content) // error调用
        // this.$refs.message.warning(content) // warning调用
        // this.$notify({
        //   title:'登录已过期',
        //   message:'登录已过期...',
        //   type:'error',
        //   duration:2000
        // })
        // router.push({
        //   name: "login",
        //   query: { title: "登录已过期" },
        // });
        return {
          type: enums.resultType.failed,
          data: response.data
        };
        // this.$router.push({ name: "login" });
        break;
        case 304:
          console.log("message:",Message);
          // Message.info("登录已过期") // info调用
          // this.$refs.message.success(content) // success调用
          // this.$refs.message.error(content) // error调用
          // this.$refs.message.warning(content) // warning调用
          // this.$notify({
          //   title:'登录已过期',
          //   message:'登录已过期...',
          //   type:'error',
          //   duration:2000
          // })
          router.push({
            name: "login",
            query: { title: "登录失败" },
          });
          return {
            type: enums.resultType.failed,
            data: response.data
          };
          // this.$router.push({ name: "login" });
          break;
      default:
        // router.push({
        //   name: "login",
        //   query: { title: "登录异常" },
        // });
        return {
          type: enums.resultType.failed,
          data: response.data
        };
        console.log("code:", response.data.code, ",message:", response.data.msg);
        break;
    }
    return response.data;
  },
  error => {
    // Toast.fail(error.message);
    return Promise.reject(error);
  }
);


export default service;